module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qleg10-144babde388852a76a794cbd32af5110.jpg";